import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const FOOTER_LINKS = [
  { label: 'Документы', to: '/documents' },
  { label: 'Контакты', to: '/contacts' },
  { label: 'Информация о юр. лице', to: '/legal-info' },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        {/* Логотип и описание */}
        <div className={styles.brand}>
          <Link to="/" className={styles.logo}>
            <span className={styles.logoAccent}>Терушкин</span>
            <span>&nbsp;ОС</span>
          </Link>
          <p className={styles.tagline}>Клуб по эндокринологии и превентивной медицине</p>
        </div>

        {/* Ссылки */}
        <nav className={styles.links}>
          {FOOTER_LINKS.map(({ label, to }) => (
            <Link key={label} to={to} className={styles.link}>
              {label}
            </Link>
          ))}
        </nav>

        {/* Техподдержка */}
        <a
          href="https://t.me/Teruskin"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.support}
        >
          Техподдержка: @Teruskin
        </a>

        {/* Копирайт */}
        <p className={styles.copyright}>
          &copy; {currentYear} Терушкин ОС. Все права защищены.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
